export const AUTH_CONFIG = {
  API_BASE_URL: process.env.REACT_APP_THOMAS_AUTH_ENDPOINT || 'https://auth.thomasnet.com',
  API_SIGNUP_PATH: '/a/signup',
  API_SIGNIN_PATH: '/a/signin',
  API_AMISIGNEDIN_PATH: '/a/amisignedin',
  API_CHECKUSER_PATH: '/a/check-user',
  API_FORGOTPASSWORD_PATH: '/a/forgotpassword',
  API_RESETPASSWORD_PATH: '/a/resetpassword',
  API_REFRESHTOKEN_PATH: '/a/refresh-token',
  API_USERINFO_PATH: '/admin/a/users/',
  API_AUTH_SECRET_KEY_VALUE: process.env.REACT_APP_API_AUTH_SECRET_KEY || '',
  THOMASNET_COOKIE_OPTIONS: { path: '/' } //, domain: ".thomasnet.com" }
};
